import TRANSLATION_ACCESSIBILITY_AR from './accessibility/translation';
import TRANSLATION_BOOKING_AR from './booking/translation';
import TRANSLATION_EVENTS_AR from './events/translation';
import TRANSLATION_EXPERIENCES_AR from './experiences/translation';
import TRANSLATION_FORM_AR from './form/translation';
import TRANSLATION_LANDING_PAGES_AR from './landingPages/translation';
import TRANSLATION_RESERVE_AR from './reserve/translation';
import TRANSLATION_SIGNIN_AR from './signin/translation';
import TRANSLATION_DATES_AR from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_AR,
  ...TRANSLATION_BOOKING_AR,
  ...TRANSLATION_DATES_AR,
  ...TRANSLATION_EVENTS_AR,
  ...TRANSLATION_EXPERIENCES_AR,
  ...TRANSLATION_FORM_AR,
  ...TRANSLATION_LANDING_PAGES_AR,
  ...TRANSLATION_RESERVE_AR,
  ...TRANSLATION_SIGNIN_AR,
};
